import actions from "@iso/redux/languageSwitcher/actions";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import config from "./config";

const { changeLanguage } = actions;

export default function LanguageSwitcher() {
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const dispatch = useDispatch();
  return (
    <div style={{ display: "flex" }}>
      <div>
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          onClick={() => setTooltipOpen(!tooltipOpen)}
          className="cursor-pointer mr-10 sm:mr-2"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2.91063 2.91063C4.77427 1.04698 7.30191 0 9.9375 0C12.5731 0 15.1007 1.04698 16.9644 2.91063C18.828 4.77427 19.875 7.30191 19.875 9.9375C19.875 11.2425 19.618 12.5347 19.1186 13.7404C18.6192 14.9461 17.8872 16.0416 16.9644 16.9644C16.0416 17.8872 14.9461 18.6192 13.7404 19.1186C12.5347 19.618 11.2425 19.875 9.9375 19.875C8.63249 19.875 7.34026 19.618 6.13458 19.1186C4.92891 18.6192 3.83341 17.8872 2.91063 16.9644C1.98784 16.0416 1.25585 14.9461 0.756447 13.7404C0.257041 12.5347 0 11.2425 0 9.9375C6.62737e-08 7.30191 1.04698 4.77427 2.91063 2.91063ZM9.9375 1.52885C7.70739 1.52885 5.56861 2.41476 3.99168 3.99168C2.41476 5.56861 1.52885 7.70739 1.52885 9.9375C1.52885 11.0417 1.74634 12.1352 2.16892 13.1554C2.59149 14.1755 3.21087 15.1025 3.99168 15.8833C4.7725 16.6641 5.69946 17.2835 6.71965 17.7061C7.73983 18.1287 8.83326 18.3462 9.9375 18.3462C11.0417 18.3462 12.1352 18.1287 13.1554 17.7061C14.1755 17.2835 15.1025 16.6641 15.8833 15.8833C16.6641 15.1025 17.2835 14.1755 17.7061 13.1554C18.1287 12.1352 18.3462 11.0417 18.3462 9.9375C18.3462 7.70739 17.4602 5.56861 15.8833 3.99168C14.3064 2.41476 12.1676 1.52885 9.9375 1.52885Z"
            fill="black"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0.611328 6.87966C0.611328 6.45748 0.953572 6.11523 1.37575 6.11523H18.4988C18.921 6.11523 19.2633 6.45748 19.2633 6.87966C19.2633 7.30184 18.921 7.64408 18.4988 7.64408H1.37575C0.953572 7.64408 0.611328 7.30184 0.611328 6.87966Z"
            fill="black"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0.611328 12.9949C0.611328 12.5727 0.953572 12.2305 1.37575 12.2305H18.4988C18.921 12.2305 19.2633 12.5727 19.2633 12.9949C19.2633 13.4171 18.921 13.7593 18.4988 13.7593H1.37575C0.953572 13.7593 0.611328 13.4171 0.611328 12.9949Z"
            fill="black"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.83262 0.116016C10.1908 0.339523 10.2999 0.811059 10.0764 1.16922C8.43513 3.79936 7.56498 6.83736 7.56498 9.9376C7.56498 13.0378 8.43513 16.0758 10.0764 18.706C10.2999 19.0641 10.1908 19.5357 9.83262 19.7592C9.47446 19.9827 9.00292 19.8735 8.77941 19.5154C6.9866 16.6425 6.03613 13.324 6.03613 9.9376C6.03613 6.55119 6.9866 3.23275 8.77941 0.359831C9.00292 0.00166927 9.47446 -0.107491 9.83262 0.116016Z"
            fill="black"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.0424 0.116016C10.4006 -0.107491 10.8721 0.00166927 11.0957 0.359831C12.8885 3.23275 13.8389 6.55119 13.8389 9.9376C13.8389 13.324 12.8885 16.6425 11.0957 19.5154C10.8721 19.8735 10.4006 19.9827 10.0424 19.7592C9.68429 19.5357 9.57513 19.0641 9.79863 18.706C11.4399 16.0758 12.3101 13.0378 12.3101 9.9376C12.3101 6.83736 11.4399 3.79936 9.79863 1.16922C9.57513 0.811059 9.68429 0.339523 10.0424 0.116016Z"
            fill="black"
          />
        </svg>
        {tooltipOpen && (
          <>
            <div
              className="bg-transparent fixed inset-0 z-[60] outline-none focus:outline-none"
              onClick={() => setTooltipOpen(false)}
            ></div>
            <ul className="z-[60] mt-4 absolute transition duration-150 ease-in-out -ml-12 shadow-lg bg-white rounded-xl">
              {config.options.map((option) => {
                const { languageId, text } = option;

                return (
                  <li
                    key={languageId}
                    className="p-4 first:rounded-t-xl last:rounded-b-xl hover:bg-gray-100 hover:text-primary cursor-pointer"
                    onClick={() => {
                      dispatch(changeLanguage(languageId));
                      setTooltipOpen(false);
                    }}
                  >
                    {text}
                  </li>
                );
              })}
            </ul>
          </>
        )}
      </div>
    </div>
  );
}
